// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #F0F8E7;
  margin: 0;
  font-family: 'Rubik', sans-serif;
}

.navigation-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #FFFFFF;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  box-sizing: border-box;
  z-index: 1000;
}

.nav-logo {
  height: 60px;
}

.nav-logo-img {
  max-width: 100%;
  max-height: 100%;
}

.menu-icon {
  display: none;
  cursor: pointer;
  font-size: 24px;
}

.nav-buttons {
  display: flex;
  align-items: center;
  transition: max-height 0.3s ease;
}

.nav-link {
  display: flex;
  align-items: center;
  margin-left: 20px;
  color: black;
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 20px;
  transition: background-color 0.3s ease;
  font-weight: bold;
  font-size: 20px;
}

.nav-link:hover,
.nav-link.active {
  background-color: var(--highlight-color);
}

.nav-icon {
  margin-right: 10px;
}

.logout-button {
  color: red;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  padding: 10px;
}

.logout-button:hover {
  background-color: red;
  color: black;
}

@media (max-width: 768px) {
  .menu-icon {
    display: block;
  }

  .nav-buttons {
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
    width: 100%;
    background-color: #FFFFFF;
    position: absolute;
    top: 70px;
    left: 0;
  }

  .nav-buttons.show-menu {
    max-height: 600px; 
  }

  .nav-link {
    margin: 10px 0;
    font-size: 16px;
  }

  .nav-logo {
    height: 50px;
  }
}

.modal-overlay1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content1 {
  background: #A5D6A7;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 350px;
  max-width: 90%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-buttons1 {
  margin-top: 20px;
  display: flex;
  justify-content: space-evenly;
}

.confirm-button1 {
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.confirm-button1:hover {
  background-color: #e04343;
}

.cancel-button1 {
  background-color: #dddddd;
  color: #333333;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.cancel-button1:hover {
  background-color: #c7c7c7;
}

@media (max-width: 768px) {
  .modal-content1 {
    padding: 20px;
    width: 280px; 
  }
  
  .modal-buttons1 {
    margin-top: 15px;
  }
  
  .confirm-button1,
  .cancel-button1 {
    padding: 8px 16px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/NavigationBar.css"],"names":[],"mappings":"AAGA;EACE,yBAAyB;EACzB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap');\n@import './Colors.css';\n\nbody {\n  background-color: #F0F8E7;\n  margin: 0;\n  font-family: 'Rubik', sans-serif;\n}\n\n.navigation-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: #FFFFFF;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 70px;\n  box-sizing: border-box;\n  z-index: 1000;\n}\n\n.nav-logo {\n  height: 60px;\n}\n\n.nav-logo-img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.menu-icon {\n  display: none;\n  cursor: pointer;\n  font-size: 24px;\n}\n\n.nav-buttons {\n  display: flex;\n  align-items: center;\n  transition: max-height 0.3s ease;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n  color: black;\n  text-decoration: none;\n  padding: 10px 15px;\n  border-radius: 20px;\n  transition: background-color 0.3s ease;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  background-color: var(--highlight-color);\n}\n\n.nav-icon {\n  margin-right: 10px;\n}\n\n.logout-button {\n  color: red;\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 10px;\n}\n\n.logout-button:hover {\n  background-color: red;\n  color: black;\n}\n\n@media (max-width: 768px) {\n  .menu-icon {\n    display: block;\n  }\n\n  .nav-buttons {\n    flex-direction: column;\n    max-height: 0;\n    overflow: hidden;\n    width: 100%;\n    background-color: #FFFFFF;\n    position: absolute;\n    top: 70px;\n    left: 0;\n  }\n\n  .nav-buttons.show-menu {\n    max-height: 600px; \n  }\n\n  .nav-link {\n    margin: 10px 0;\n    font-size: 16px;\n  }\n\n  .nav-logo {\n    height: 50px;\n  }\n}\n\n.modal-overlay1 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content1 {\n  background: #A5D6A7;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  width: 350px;\n  max-width: 90%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.modal-buttons1 {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.confirm-button1 {\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.confirm-button1:hover {\n  background-color: #e04343;\n}\n\n.cancel-button1 {\n  background-color: #dddddd;\n  color: #333333;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.cancel-button1:hover {\n  background-color: #c7c7c7;\n}\n\n@media (max-width: 768px) {\n  .modal-content1 {\n    padding: 20px;\n    width: 280px; \n  }\n  \n  .modal-buttons1 {\n    margin-top: 15px;\n  }\n  \n  .confirm-button1,\n  .cancel-button1 {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
